import {isJustEat} from '~/shared/config';

export const instagramProfile = `https://www.instagram.com/${isJustEat ? 'justeatisrael' : '10bis'}/`;
export const facebookPage = isJustEat ? 'https://www.facebook.com/profile.php?id=61585313152633' : 'https://www.facebook.com/10bis/';
export const tiktokProfile = isJustEat ? 'https://www.tiktok.com/@just.eat.il' : '';
